export var SET_FILTER = 'set_filter';
export var RESET_FILTER = 'reset_filter';
export var SET_ALL_ADDRESSES = 'set_all_addresses';
export var SET_INITIAL_FILTERS = 'set_intial';
export var SET_SEARCH_THIS_AREA_ADDRESS = 'set_search_this_area_address';
export var ADD_PROGRAM = 'add_program';
export var ADD_PROGRAMS = 'add_programs';
export var REMOVE_PROGRAM = 'remove_program';
export var REPLACE_PROGRAMS = 'replace_programs';
export var REMOVE_ALL_PROGRAMS = 'remove_all_programs';
//# sourceMappingURL=constants.js.map